import React from "react"
import { MyUIHelpers } from "@macashipo/mlib"
const MUI_checkidle_countdown = React.lazy(() =>
  import("./Types/checkidle_countdown")
)

const List = {
  checkidle_countdown: MUI_checkidle_countdown,
}
const MyUIOne = {
  init() {
    MyUIHelpers.addTypesFromListLazy(List)
  },
}

export default MyUIOne
